import DOMPurify from "dompurify";
import { Category, SubCategory } from "../types/types";

export function formatDate(dateStr: string) {
    const date = new Date(dateStr);
    return date.toLocaleString("sq-AL", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Tirane",
    });
}

export function replaceStringSpaces(str: string) {
  return str.replace(/\s+/g, "-");
}

export function toLeagueSlug(name: string): string {
  return name
    .trim()
    .replace(/[–—]/g, "-")
    .replace(/\s+/g, "-")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/-+/g, "-")
    .toLowerCase();
}

export function findLeagueBySlug(
  categories: Category[] | null | undefined,
  slug: string | undefined
): SubCategory | undefined {
  if (!categories || !slug) return undefined;

  const target = toLeagueSlug(decodeURIComponent(slug));

  const walk = (nodes: SubCategory[]): SubCategory | undefined => {
    for (const node of nodes) {
      if (node.referenceLeagueId && toLeagueSlug(node.name) === target) {
        return node;
      }
      if (node.subCategories?.length) {
        const nested = walk(node.subCategories);
        if (nested) return nested;
      }
    }
    return undefined;
  };

  for (const category of categories) {
    const match = walk(category.subCategories || []);
    if (match) return match;
  }

  return undefined;
}

export const splitTextByDelimiter = (text: string, delimiter: string = "\n") => {
    return text
        .split(delimiter)
        .map((section) => section.trim())
        .filter((section) => section !== "");
};

export const splitTextByDelimiter2 = (htmlString: string): string[] => {
    if (!htmlString) return [];

    return htmlString
        .replace(/&nbsp;–&nbsp;/g, '&nbsp;–')
        .replace(/&nbsp;/g, ' ')
        .split("\n")
        .map((section) => DOMPurify.sanitize(section.trim()));
};

export const  parseLanguageLocaleString = (locale: any): string => {
    const defaultLocale = "al";
    if(locale) {
        return locale;
    } else {
        return defaultLocale;
    }
}